import { SelectItem } from 'primeng/api';
import { FILTER_VALUE } from './filters.constants';

export const labelMap: Record<string, string> = {
    [FILTER_VALUE.ALL]: 'Tous',
    [FILTER_VALUE.ACTIVE]: 'Active',
    [FILTER_VALUE.INACTIVE]: 'Inactive',
    [FILTER_VALUE.TODAY]: 'Today',
    [FILTER_VALUE.HEALTHY]: 'Healthy',
  };

export const AlarmStatusOptions: SelectItem[] = [
  {
    label: labelMap[FILTER_VALUE.ALL],
    value: FILTER_VALUE.ALL,
  },
  {
    label: labelMap[FILTER_VALUE.ACTIVE],
    value: FILTER_VALUE.ACTIVE,
  },
  {
    label: labelMap[FILTER_VALUE.INACTIVE],
    value: FILTER_VALUE.INACTIVE,
  },
];



